import { useInfiniteQuery } from '@tanstack/react-query';
import { fetchPlayers } from '@api-service/players';
import type {
  GetPlayersOptions,
  PlayerListResponse
} from '@api-service/players';

export type UsePlayersOptions = Omit<GetPlayersOptions, 'cursor'> & {
  enabled?: boolean;
  staleTime?: number;
};

const FIVE_MINUTES_IN_MS = 5 * 60 * 1000;

export const usePlayers = ({
  enabled = true,
  staleTime = FIVE_MINUTES_IN_MS,
  ...options
}: UsePlayersOptions = {}) =>
  useInfiniteQuery<PlayerListResponse, Error>({
    queryKey: [
      'players',
      options.accessToken ? 'auth' : 'anon',
      options.ids,
      options.optaIds,
      options.position,
      options.teamId,
      options.minGameweek,
      options.maxGameweek,
      options.minPrice,
      options.maxPrice,
      options.search,
      options.sortBy,
      options.sortDirection,
      options.include,
      options.exclude,
      options.limit,
      options.season
    ],
    queryFn: ({ pageParam }: { pageParam?: string }) =>
      fetchPlayers({ ...options, cursor: pageParam }),
    getNextPageParam: (lastPage) =>
      lastPage.meta?.hasMore
        ? lastPage.meta.nextCursor ?? undefined
        : undefined,
    keepPreviousData: true,
    enabled,
    staleTime
  });
